export default __webpack_public_path__ + "static/media/storageUnit1-afterC-1920w.390b0f07.avif";